<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/bills-receipts-logo.png" draggable="false">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <entitySelectorForm />
  </div>
</template>

<script>
// @ is an alias to /src
/* import HelloWorld from '@/components/HelloWorld.vue' */
import entitySelectorForm from '@/components/auth/entitySelectorForm.vue';
export default {
  name: 'HomeView',
  components: {
  /*   HelloWorld, */ entitySelectorForm
  }
}
</script>
<style scoped>
img {
  filter: drop-shadow(0px 0px 25px #009688);
}
</style>